module.exports = __webpack_public_path__ + "static/media/manager-vacancies.454d0891.svg";